import React from "react";
import toast from "react-hot-toast";
import { Link2 } from "lucide-react";

// Link riêng của một mục trong khoá học: /course/<mã khoá>/<mã mục>
export const lessonLink = (courseId, lessonId) =>
  `${window.location.origin}/course/${courseId}/${lessonId}`;

// Link của một chuyên đề: /topic/<mã>
export const topicLink = (topicId) => `${window.location.origin}/topic/${topicId}`;

// Trên điện thoại mở bảng chia sẻ của máy (gửi thẳng qua Zalo, Messenger...),
// trên máy tính thì sao chép link
const shareLink = async (url, title) => {
  const isTouch = window.matchMedia?.("(pointer: coarse)").matches;
  if (isTouch && navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch (err) {
      if (err.name === "AbortError") return; // người dùng tự đóng bảng chia sẻ
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Đã sao chép link, dán để gửi cho học sinh.");
  } catch (err) {
    window.prompt("Sao chép link bên dưới:", url);
  }
};

// label: chữ hiện cạnh biểu tượng (bỏ trống thì chỉ có biểu tượng)
const ShareLinkButton = ({ url, title, className = "", label }) => (
  <button
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      shareLink(url, title);
    }}
    className={`flex items-center text-xs font-semibold text-gray-500 hover:text-indigo-600 px-1.5 py-1 rounded flex-shrink-0 ${className}`}
    title="Sao chép link riêng để gửi cho học sinh"
    aria-label={label || "Link riêng"}
  >
    <Link2 size={16} />
    {label && <span className="ml-1">{label}</span>}
  </button>
);

export default ShareLinkButton;
